import SettingsUserIcon from './component'

export default SettingsUserIcon